import React from "react";

const FoodDelivery = (props) => {
  const _width = props.width || 24;
  return (
    <svg
      id="icon-food-delivery"
      xmlns="http://www.w3.org/2000/svg"
      data-name="icon-food-delivery"
      viewBox="0 0 24 24"
      width={_width}
      {...props}
    >
      <path d="M22.312,19.519l-3.578,3.205c-.917,.821-2.105,1.276-3.336,1.276H2.654c-1.016,0-1.761-.955-1.515-1.94h0c.89-3.561,4.09-6.06,7.761-6.06h3.7c.909,0,1.77,.577,1.985,1.461,.276,1.134-.504,2.208-1.595,2.364l-3.808,.544c-.547,.078-.927,.585-.849,1.132h0c.078,.547,.585,.927,1.132,.849l3.808-.544c1.392-.199,2.526-1.135,3.05-2.371l3.333-2.934c.838-.73,2.109-.641,2.838,.197h0c.723,.832,.642,2.091-.182,2.822Zm.282-7.519c-.748-4.568-4.37-8.157-8.951-8.863,0,0,0,0,0,0,.224-.323,.357-.714,.357-1.137,0-1.105-.895-2-2-2s-2,.895-2,2c0,.423,.133,.814,.357,1.137h0C5.776,3.843,2.154,7.432,1.406,12h-.406c-.552,0-1,.448-1,1H0c0,.552,.448,1,1,1H23c.552,0,1-.448,1-1h0c0-.552-.448-1-1-1h-.406Z" />
    </svg>
  );
};

export default FoodDelivery;
